export const checkListLoading =  ({store})  => store.checkListReducer.loading;

export const checkListError =  ({store})  => store.checkListReducer.error;

export const checkListData =  ({store})  => store.checkListReducer.data;